import { render, staticRenderFns } from "./textarea-field.vue?vue&type=template&id=487c86af&scoped=true&lang=pug"
import script from "./textarea-field.vue?vue&type=script&lang=js"
export * from "./textarea-field.vue?vue&type=script&lang=js"
import style0 from "./textarea-field.vue?vue&type=style&index=0&id=487c86af&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c86af",
  null
  
)

export default component.exports